import { render, staticRenderFns } from "./newRanking.vue?vue&type=template&id=db75c062&scoped=true&"
import script from "./newRanking.vue?vue&type=script&lang=js&"
export * from "./newRanking.vue?vue&type=script&lang=js&"
import style0 from "./newRanking.vue?vue&type=style&index=0&id=db75c062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db75c062",
  null
  
)

export default component.exports